import { PortalType } from '@ats/api/cm';
import { combineLatestWith, map, Observable, of } from 'rxjs';

// This is temporary until we can remove from settings
// to avoid ciruclar dependencies

export const routeWithContext: ({
	client,
	culture,
	portal,
}: {
	client?: string;
	culture?: string;
	portal?: PortalType;
}) => (path: string[]) => string[] =
	({ client, culture, portal }) =>
	path => {
		if (portal === PortalType.InternalPortal) {
			return [...path];
		}

		if (!client) {
			throw new Error('Unable to determine client');
		}

		if (client && culture) {
			return [client, culture, ...path];
		}

		const [pathClient, pathCulture] = window.location.pathname
			.split('/')
			.filter(path => !!path.length);
		return [pathClient, pathCulture, ...path];
	};

export const routeWithContext$: (
	client$: Observable<string>,
	culture$: Observable<string>,
	portal?: PortalType
) => (path: string[]) => Observable<string[]> = (client$, culture$, portal) => path => {
	return portal && portal === PortalType.InternalPortal
		? of([...path])
		: client$.pipe(
				combineLatestWith(culture$),
				map(basePaths => [...basePaths, ...path])
			);
};

export const routeWithNewCulture: ({
	client,
	portal,
}: {
	client?: string;
	portal?: PortalType;
}) => (path: string[], culture: string) => string[] =
	({ client, portal }) =>
	(path, culture) => {
		if (portal === PortalType.InternalPortal) {
			return [...path];
		}

		return routeWithContext({ client, culture, portal })(path);
	};

export const routeWithNewCulture$: (
	client$: Observable<string>,
	portal?: PortalType
) => (path: string[], culture: string) => Observable<string[]> =
	(client$, portal) => (path, culture) => {
		return portal && portal === PortalType.InternalPortal
			? of([...path])
			: routeWithContext$(client$, of(culture), portal)(path);
	};
